import React, { useState } from "react";
import PageTitle from "../../components/ui_components/pageTitle";
import Image from "next/image";
import Button from "./button";
import { PlatformOptions } from "../../helpers/filter/filter-options";
import ScrollToButton from "./scrollToButton";
import { useHeroHooks } from "./HeroHooks";
import { useTranslation } from "next-i18next";
import HeroHead from "./HeroHead";
import { categoryTranslateKey, subCategoryTranslateKey } from "../../helpers/constants/translate";
import StoreSearchPopup from "./StoreSearchPopup";
import { t } from "i18next";

const HeroMobile = ({ lang, isProduction }) => {
  const {
    router,
    subCategories,
    categories,
    selectedSubCategory,
    selectedCategory,
    filterOptions,
    isSocialMediaActive,
    getSubCategories,
    handleCategoryChange,
    handleSubCategoryChange,
    handleClickDelivery,
    handleClickIcon,
  } = useHeroHooks();
  const { t: heroTranslate } = useTranslation("hero");
  const { t: translate } = useTranslation("categories");

  const [showStoreSearchPopup, setShowStoreSearchPopup] = useState(false);

  const isDisabled = ["categories", ""].includes(selectedCategory);

  const search = async () => {
    if (isDisabled) {
      return;
    }
    await router.push({
      pathname: "/categories/[category]",
      query: {
        category: selectedCategory?.toLocaleLowerCase(),
        extraOptions: JSON.stringify(filterOptions),
      },
    });
  };

  return (
    <>
      <HeroHead isProduction={isProduction}></HeroHead>
      <div className="relative py-2 mb-20 ">
        <div className="flex flex-col mx-4 md:mx-20 gap-y-5 mb-10">
          <h1 className="xs:text-[1.8rem] md:text-[2.4rem] lg:text-[2.625rem]  text-[#233377] text-center ">
            {heroTranslate("MAIN_LEAD_MSG")}
            <span className="text-[#F2C335]">{heroTranslate("MAIN_LEAD_MSG_2")}</span>
          </h1>

          <div className="">
            <div onClick={() => setShowStoreSearchPopup(true)}>
              <Button className="w-full text-[#233377] text-base md:text-xl w-border-2 py-4 border-[#233377]">
                {heroTranslate("give_opinion")}
              </Button>
            </div>
          </div>

          <div className="custom-select border-4 border-gray-200 rounded-[10px]">
            <select
              id="select-categories"
              className="bg-white border-4 border-gray-100 text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block 
                w-full h-14 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
                dark:focus:border-blue-500 cursor-pointer"
              onChange={handleCategoryChange}
              value={selectedCategory}
              onClick={() => getSubCategories()}
            >
              <option key="no_category" value="">
                {heroTranslate("category_default_option")}
              </option>
              {categories.map((option: any, index: number) => (
                <option value={`${option.attributes.slug}`} key={`category__${index}`}>
                  {translate(categoryTranslateKey(option.attributes.slug))}
                </option>
              ))}
            </select>
          </div>

          {subCategories.length != 0 && selectedCategory != "categories" && (
            <div className="custom-select flex-[3] mb-[5px] border-4 border-gray-200 rounded-[10px]">
              <select
                id="countries"
                className="bg-white border-4 border-gray-100 text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block 
                  w-full h-14 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
                  dark:focus:border-blue-500 cursor-pointer"
                onChange={handleSubCategoryChange}
                value={selectedSubCategory}
              >
                {subCategories.map((option: any, index) => (
                  <option value={option.name} key={`sub_category__${index}`}>
                    {translate(subCategoryTranslateKey(option.name))}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="flex gap-2">
            <div className="flex-1 border-4 border-gray-200 rounded-[10px]">
              <div className="bg-white border-4 border-gray-100 h-14 flex items-center justify-center rounded-md cursor-pointer gap-2">
                <input
                  type={"checkbox"}
                  id="checkbox-associated"
                  onClick={() => handleClickDelivery()}
                />
                <label htmlFor="checkbox-associated" className="ml-2 cursor-pointer">
                  {heroTranslate("delivery")}
                </label>
              </div>
            </div>
            <div className="flex-1 border-4 border-gray-200 rounded-[10px]">
              <div className="flex bg-white h-14 border-4 border-gray-100 items-center justify-evenly rounded-md gap-2">
                {PlatformOptions.map((item, index) => (
                  <label
                    key={`platform__${index}`}
                    className={`flex hover:cursor-pointer ${isSocialMediaActive[item.value] ? "p-[3px] rounded-md bg-yellow" : ""}`}
                  >
                    <Image
                      id={item.value}
                      src={item.icon ?? ""}
                      alt={item.icon + "logo"}
                      width={40}
                      height={38}
                      onClick={() => handleClickIcon(item)}
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                      }}
                    />
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div>
            <button
              disabled={isDisabled}
              className={`text-white font-semibold bg-[#233377] w-full h-16 rounded-xl m-auto ${isDisabled ? "opacity-50" : ""}`}
              onClick={search}
            >
              {heroTranslate("search")}
            </button>
          </div>
        </div>
        <ScrollToButton
          className={`flex justify-center absolute z-10 w-full bottom-[-7rem]`}
          toId="carousel-categories"
          toRef={null}
          duration={500}
          adjustPosition={-96}
        />
      </div>

      <StoreSearchPopup
        isOpen={showStoreSearchPopup}
        onClose={() => setShowStoreSearchPopup(false)}
        title={heroTranslate("share_experience")}
        placeholder={t("search_store")}
      />
    </>
  );
};

export default HeroMobile;
